import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { CardNumberElement, CardExpiryElement, CardCvcElement } from '@stripe/react-stripe-js';

import api from 'api';

import css from 'css';

import { msg, gtmPush, opportunityErrorMessage } from 'helpers';

import { Input } from 'partials/formElements';
import CheckmarkCircle from 'images/CheckmarkCircle';

import {
    setCheckoutNextCallback,
    setCheckoutCustomer,
    setCheckoutLoading,
    setCheckoutError,
    setCheckoutOpportunityTransactionId,
    setCheckoutOpportunityReserversdAmount,
    setTermsVisibility
} from 'store';

const Wrapper = styled.div``

const InputRow = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 30px;
    align-items: center;

    .input-wrapper {
        width: 100%;
        margin: 0 5px;

        input {
            width: 100%;
            height: auto;
            padding: 15px;
            background: #E3EFFD;
            border: none;
            border-bottom: 4px solid ${css.colors.blue};
        }

        label {
            color: #FFF;
        }

        &.error {
            input {
                border-color: ${css.colors.red};
            }
        }

        &:first-child {
            margin-right: 0;
        }

        &:last-child {
            margin-right: 0;
        }
    }

    svg {
        position: absolute;
        top: 40px;
        right: 15px;
        opacity: 0;
    }

    &.valid {
        .input-wrapper input {
            padding-right: 50px;
        }

        svg {
            opacity: 1;
        }
    }
`

const Form = styled.form``;

const FormSpacer = styled.div`
    display: block;
    height: 30px;
`;

const StyledCardNumberElement = styled(CardNumberElement)`
    width: 100%;
    height: auto;
    padding: 15px;
    background: #E3EFFD;
    border: none;
    border-bottom: 4px solid ${css.colors.blue};

    ${props => props.error ? `
        &.StripeElement--invalid{
            color: ${css.colors.main};
            border-bottom: 4px solid ${css.colors.red};

            &:after {
                color: ${css.colors.red};
                content: '${props.error}';
                display: block;
                position: absolute;
                left: 0;
                bottom: -29px;
            }
        }
    ` : ``}
`;

const StyledCardExpiryElement = styled(CardExpiryElement)`
    width: 100%;
    height: auto;
    padding: 15px;
    background: #E3EFFD;
    border: none;
    border-bottom: 4px solid ${css.colors.blue};

    ${props => props.error ? `
        &.StripeElement--invalid{
            color: ${css.colors.main};
            border-bottom: 4px solid ${css.colors.red};

            &:after {
                color: ${css.colors.red};
                content: '${props.error}';
                display: block;
                position: absolute;
                left: 0;
                bottom: -29px;
            }
        }
    ` : ``}
`;

const StyledCardCvcElement = styled(CardCvcElement)`
    width: 100%;
    height: auto;
    padding: 15px;
    background: #E3EFFD;
    border: none;
    border-bottom: 4px solid ${css.colors.blue};

    ${props => props.error ? `
        &.StripeElement--invalid{
            color: ${css.colors.main};
            border-bottom: 4px solid ${css.colors.red};

            &:after {
                color: ${css.colors.red};
                content: '${props.error}';
                display: block;
                position: absolute;
                left: 0;
                bottom: -29px;
            }
        }
    ` : ``}
`;

class CardPayment extends Component {
    constructor() {
        super();

        this.state = {
            paymentToken: null,
            tokenLoaded: null,
            errors: {
                street: '',
                postalCode: '',
            },
            paymentErrors: {
                cardNumber: '',
                cardExpiry: '',
                cardCvc: '',
            },
            isValid: {
                street: false,
                postalCode: false,
            }
        }
    }

    componentDidMount() {
        this.props.setCheckoutNextCallback(this._onSubmit.bind(this));

        const paymentParameters = {
            opportunityId: this.props.opportunity.id,
            customerId: this.props.opportunity.customerId,
            opportunityAmount: this.props.opportunity.payableAmount
        }

        this.setState({ tokenLoaded: false });

        api.createPaymentIntent(paymentParameters).then(result => {
            this.setState({ paymentToken: result.data.paymentToken });
            this.setState({ tokenLoaded: true });
        });

        gtmPush({
            'event': 'virtual_pageview',
            'pageTitle': 'Checkout - Betailing',
            'pageURI': '/checkout/betaling/kort', 
        });
    }

    componentDidUpdate(prevProps, prevState) {
        if (prevState.tokenLoaded !== this.state.tokenLoaded) {
            if (this.state.tokenLoaded) {
                this.props.setCheckoutLoading(false);
            } else {
                this.props.setCheckoutLoading(true)
            }
        }
    }

    _onInputChange(key, value) {
        this.setState({
            errors: { ...this.state.errors, [key]: '' }
        });

        if (key === 'postalCode') {
            value = value.toString()
                .replace(/[^\d]/g, '')
                .substring(0, 4);
        }

        this.props.setCheckoutCustomer({ ...this.props.customer, [key]: value });
    }

    _onPaymentInputChange(key, error) {
        if (error) {
            this.setState(state => ({
                paymentErrors: { ...state.paymentErrors, [key]: error.message },
            }));

            return false;
        }

        this.setState(state => ({
            paymentErrors: { ...state.paymentErrors, [key]: '' },
        }));

        return true;
    }

    _validateInput(key) {
        const value = this.props.customer[key];

        if (!value) {
            this.setState(state => ({
                errors: { ...state.errors, [key]: msg('fieldRequired') },
                isValid: { ...state.isValid, [key]: false }
            }));

            return false;
        }

        this.setState(state => ({
            errors: { ...state.errors, [key]: '' },
            isValid: { ...state.isValid, [key]: true }
        }));

        return true;
    }

    _onSubmit = () => {
        const { termsAccepted } = this.props.checkout;
        if (!this.props.stripe || !this.props.elements) {
            return false;
        }

        const isValid = !Object.keys(this.state.isValid).filter(key => {
            return !this._validateInput(key);
        }).length;

        if(!termsAccepted) {
            this.props.setTermsVisibility(true);
            return false;
        }

        if (!this.props.opportunity.transactionId) {
            return this._onPaymentProcessing().then((paymentResult) => {
                if (!isValid || !paymentResult) {
                    return false;
                }

                return Promise.all([
                    this._onCustomerUpdate(),
                    this._onOpportunityUpdate()
                ]).then(() => {
                    return this._onTimeSchedualCreation().then(() => {
                        return true;
                    }).catch(() => {
                        return false;
                    });
                }).catch(error => {
                    this.props.setCheckoutError(opportunityErrorMessage(error, 'unableToUpdatePayment'));

                    return false;
                });
            }).catch(error => {
                this.props.setCheckoutError(msg('unableToPay'));

                return false;
            });
        }

        if (!isValid) {
            return false;
        }

        return Promise.all([
            this._onCustomerUpdate(),
            this._onOpportunityUpdate(),
        ]).then(() => {
            return this._onTimeSchedualCreation().then(() => {
                return true;
            }).catch(() => {
                return false;
            });
        }).catch(error => {
            this.props.setCheckoutError(opportunityErrorMessage(error, 'unableToUpdatePayment'));

            return false;
        });
    }

    _onPaymentProcessing() {
        const parameters = {
            payment_method: {
                card: this.props.elements.getElement(CardNumberElement)
            }
        };

        return this.props.stripe.confirmCardPayment(this.state.paymentToken, parameters).then(({ paymentIntent, error }) => {
            if (error && error.type === 'validation_error') {
                return false;
            }

            if (error) {
                this.props.setCheckoutError(msg('unableToPay'));

                return false;
            }

            if (paymentIntent.status !== 'succeeded') {
                this.props.setCheckoutError(msg('unableToConfirmPayment'));

                return false;
            }

            this.props.setCheckoutOpportunityTransactionId(paymentIntent.id);
            this.props.setCheckoutOpportunityReserversdAmount(paymentIntent.amount / 100);

            return true;
        }).catch(error => {
            this.props.setCheckoutError(msg('unableToPay'));

            return false;
        });
    }

    _onCustomerUpdate() {
        const { customer } = this.props;

        const parameters = {
            firstName: customer.firstName ? customer.firstName.trim() : null,
            lastName: customer.lastName ? customer.lastName.trim() : null,
            personalNumber: customer.personalNumber ? customer.personalNumber.trim() : null,
            email: customer.email ? customer.email.trim() : null,
            phone: customer.phone ? customer.phone.trim() : null,
            country: null,
            city: null,
            street: customer.street ? customer.street.trim() : null,
            postalCode: customer.postalCode ? customer.postalCode.trim() : null,
            partialObject: customer.partialObject,
        }

        return api.updateCustomer(customer.id, parameters);
    }

    _onOpportunityUpdate() {
        const { opportunity } = this.props;

        if (!opportunity.id) {
            return Promise.reject(new Error('Missing opportunity id'));
        }

        const parameters = {
            customerId: opportunity.customerId,
            educationalGoal: opportunity.educationalGoal,
            attachments: opportunity.attachments,
            comment: opportunity.comment,
            programs: opportunity.programs,
            courses: opportunity.courses,
            transactionId: opportunity.transactionId,
            reservedAmount: opportunity.reservedAmount,
            paymentMethod: opportunity.paymentMethod,
            coupon: opportunity.coupon,
            partialObject: opportunity.partialObject,
        }

        return api.updateOpportunity(opportunity.id, parameters);
    }

    _onTimeSchedualCreation() {
        const { autumnSchemaCourseOccasionIds, springSchemaCourseOccasionIds } = this.props.timeSchedule;

        const courseOccasionIds = autumnSchemaCourseOccasionIds.concat(springSchemaCourseOccasionIds);

        const parameters = {
            courseOccasionIds: courseOccasionIds,
            opportunityId: this.props.opportunity.id,
        }

        return api.createTimeScheduler(parameters).then(response => {
            if(response.data.error) setCheckoutError('Noe gikk galt ved lagring av timeplanen');
            return response;
        }).catch(error => {
            return error;
        });
    }

    render() {
        const { tokenLoaded, errors, paymentErrors, isValid } = this.state;
        const { street, postalCode } = this.props.customer;

        return (
            <Wrapper>
                { tokenLoaded &&
                    <Form>
                        <InputRow>
                            <div className="input-wrapper">
                                <label for="cardNumber"> Kortnummer </label>
                                <StyledCardNumberElement
                                    error={paymentErrors.cardNumber}
                                    options={{
                                        style: {
                                            base: {
                                                fontSize: '16px',
                                                color: css.colors.main
                                            },
                                            invalid: {
                                                color: css.colors.main,
                                            },
                                        }
                                    }}
                                    onChange={e => this._onPaymentInputChange('cardNumber', e.error)}
                                />
                            </div>
                        </InputRow>
                        <InputRow>
                            <div className="input-wrapper">
                                <label for="cardExpiry"> Gyldig til </label>
                                <StyledCardExpiryElement
                                    error={paymentErrors.cardExpiry}
                                    options={{
                                        style: {
                                            base: {
                                                fontSize: '16px',
                                                color: css.colors.main
                                            },
                                            invalid: {
                                                color: css.colors.main,
                                            },
                                        }
                                    }}
                                    onChange={e => this._onPaymentInputChange('cardExpiry', e.error)}
                                />
                            </div>
                        </InputRow>
                        <InputRow>
                            <div className="input-wrapper">
                                <label for="cardCvc"> CVV </label>
                                <StyledCardCvcElement
                                    error={paymentErrors.cardCvc}
                                    options={{
                                        style: {
                                            base: {
                                                fontSize: '16px',
                                                color: css.colors.main
                                            },
                                            invalid: {
                                                color: css.colors.main,
                                            },
                                        }
                                    }}
                                    onChange={e => this._onPaymentInputChange('cardCvc', e.error)}
                                />
                            </div>
                        </InputRow>
                        <FormSpacer />
                        <InputRow className={isValid.street ? 'valid' : ''}>
                            <Input label="Adresse" value={street || ''} error={errors.street} onChange={e => this._onInputChange('street', e.target.value)} onBlur={() => this._validateInput('street')} />
                            <CheckmarkCircle />
                        </InputRow>
                        <InputRow className={isValid.postalCode ? 'valid' : ''}>
                            <Input label="Postnummer" value={postalCode || ''} error={errors.postalCode} onChange={e => this._onInputChange('postalCode', e.target.value)} onBlur={() => this._validateInput('postalCode')} />
                            <CheckmarkCircle />
                        </InputRow>
                    </Form>
                }
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    opportunity: state.opportunity,
    customer: state.customer,
    timeSchedule: state.timeSchedule,
    checkout: state.checkout
});

const actions = {
    setCheckoutNextCallback,
    setCheckoutCustomer,
    setCheckoutLoading,
    setCheckoutError,
    setCheckoutOpportunityTransactionId,
    setCheckoutOpportunityReserversdAmount,
    setTermsVisibility,
}

export default withRouter(connect(mapStateToProps, actions)(CardPayment));


// WEBPACK FOOTER //
// ./src/partials/Checkout/CardPayment.js